<template>
    <div class="automation-wizard-form-field">
        <!-- Select field -->
        <AutomationWizardFieldSelect
            v-if="field.type === 'select'"
            :field="field"
            :modelValue="modelValue"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Pipeline step opportunity field -->
        <AutomationWizardFieldPipelineStepOpp
            v-else-if="field.type === 'pipeline_step_opp'"
            :field="field"
            :modelValue="modelValue"
            :formData="formData"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Text or textarea field -->
        <AutomationWizardFieldText
            v-else-if="field.type === 'text' || field.type === 'textarea'"
            :field="field"
            :modelValue="modelValue"
            :formData="formData"
            :type="field.type"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Date field (days only) -->
        <AutomationWizardFieldDate
            v-else-if="field.type === 'date'"
            :field="field"
            :modelValue="modelValue"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Time field (hours only) -->
        <AutomationWizardFieldTime
            v-else-if="field.type === 'time'"
            :field="field"
            :modelValue="modelValue"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Date time field (combined) -->
        <AutomationWizardFieldDateTime
            v-else-if="field.type === 'date_time'"
            :field="field"
            :modelValue="modelValue"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Priority button-->
        <AutomationWizardFieldPriority
            v-else-if="field.type === 'priority_task'"
            :field="field"
            :modelValue="modelValue"
            :formData="formData"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Amount field -->
        <AutomationWizardFieldNumeric
            v-else-if="field.type === 'amount'"
            :field="field"
            :modelValue="modelValue"
            unit="currency"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Percent field -->
        <AutomationWizardFieldNumeric
            v-else-if="field.type === 'percent'"
            :field="field"
            :modelValue="modelValue"
            unit="percent"
            :max="100"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Task reminder field -->
        <AutomationWizardTaskReminder
            v-else-if="field.type === 'reminder_task'"
            :field="field"
            :modelValue="modelValue"
            @update:model-value="handleUpdateModelValue"
        />

        <!-- Document type + status field -->
        <AutomationWizardFieldDocumentTypeStatus
            v-else-if="field.type === 'document_type_status'"
            :field="field"
            :modelValue="modelValue"
            :formData="formData"
            @update:model-value="handleUpdateModelValue"
        />
    </div>
</template>

<script>
import AutomationWizardFieldSelect from './Fields/AutomationWizardFieldSelect.vue';
import AutomationWizardFieldPipelineStepOpp from './Fields/AutomationWizardFieldPipelineStepOpp.vue';
import AutomationWizardFieldText from './Fields/AutomationWizardFieldText.vue';
import AutomationWizardFieldDate from './Fields/AutomationWizardFieldDate.vue';
import AutomationWizardFieldTime from './Fields/AutomationWizardFieldTime.vue';
import AutomationWizardFieldDateTime from './Fields/AutomationWizardFieldDateTime.vue';
import AutomationWizardFieldPriority from './Fields/AutomationWizardFieldPriorityIconButton.vue';
import AutomationWizardFieldNumeric from './Fields/AutomationWizardFieldNumeric.vue';
import AutomationWizardTaskReminder from './Fields/AutomationWizardTaskReminder.vue';
import AutomationWizardFieldDocumentTypeStatus from './Fields/AutomationWizardFieldDocumentTypeStatus.vue';

export default {
    name: 'AutomationWizardFormField',
    components: {
        AutomationWizardFieldSelect,
        AutomationWizardFieldPipelineStepOpp,
        AutomationWizardFieldText,
        AutomationWizardFieldDate,
        AutomationWizardFieldTime,
        AutomationWizardFieldDateTime,
        AutomationWizardFieldPriority,
        AutomationWizardFieldNumeric,
        AutomationWizardTaskReminder,
        AutomationWizardFieldDocumentTypeStatus,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [String, Number, Object, Boolean, Array],
            default: '',
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['update:modelValue'],
    methods: {
        handleUpdateModelValue(modelValue) {
            this.$emit('update:modelValue', modelValue);
        },
    },
};
</script>
